import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Anwendungscontainer fehlt.');
createRoot(root).render(<App />);
